var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-auto-complete',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"size":_vm.size,"allowClear":"","data-source":_vm.dataItems,"filterOption":_vm.filterOption},on:{"select":_vm.onSelect,"change":_vm.changeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }